import React, { lazy } from 'react'
import auditAdjustmentRoutes from './AuditAdjustment/AuditAdjustmentEntriesRoutes'
import externalJournalRoutes from './ExternalJournalModule/ExternalJournalRoutes'
import GLBudgetRoutes from './GLBudget/GLBudgetRoutes'
import journalRoutes from './Journal/JournalRoutes'
import monthYearEndClosingRoutes from './MonthYearEndClosing/MonthYearEndClosingRoutes'
import recurringjournalRoutes from './RecurringJournal/RecurringJournalRoutes'
import routinejournalRoutes from './RoutineJournal/RoutineJournalRoutes'
import generateRecurringJournalRoutes from './GenerateRecurringJournal/GenerateRecurringRoutes'
import journalEnquiryRoutes from './JournalEnquiry/JournalEnquiryRoutes'
import glExportDotNetRoutes from './GLExportDotNet/GLExportDotNetRoutes'
import generalLedgerPolicyRoutes from './GeneralLedgerPolicy/GeneralLedgerPolicyRoutes'

const GeneralLedgerSubmenu = lazy(() =>
  import('./GeneralLedgerSubmenu').then(module => ({
    default: module.GeneralLedgerSubmenu,
  }))
)

const generalLedgerRoutes = [
  {
    props: { exact: true, path: '/general-ledger/:CompanyID/' },
    component: <GeneralLedgerSubmenu />,
  },
  ...journalEnquiryRoutes,
  ...journalRoutes,
  ...glExportDotNetRoutes,
  ...auditAdjustmentRoutes,
  ...routinejournalRoutes,
  ...recurringjournalRoutes,
  ...generateRecurringJournalRoutes,
  ...externalJournalRoutes,
  ...generalLedgerPolicyRoutes,
  ...monthYearEndClosingRoutes,
  ...GLBudgetRoutes, // make sure to put last
  // ...digitalReportRoutes,
]

export default generalLedgerRoutes
